import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import CandidateChip from './CandidateChip';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        padding: props => props.padding? props.padding: '10px'
    }
});

export default function ChipBasedSelector(props) {
    const classes = useStyles(props);

    const onSelectionChange = (changeTarget) => {
        props.onSelectionChange(changeTarget);
    };

    return (
        <div className={classes.root}>
            {props.ideaData.map((data) => {
                return (
                    <CandidateChip key={data.label} label={data.label} color={data.color} textColor={data.textColor} onSelectionChange={onSelectionChange} />
                );
            })}
        </div>
    );
}